import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    return {
        drawer: {
            '& .MuiDrawer-paperAnchorRight': {
                width: '276px',
                [theme.breakpoints.down(400)]: {
                    width: '270px',
                },
            },
        },
        menu: {
            padding: theme.spacing(6, 8, 6, 8),
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            '& .MuiMenuItem-root': {
                minHeight: '48px !important',
            },
        },
        button: {
            padding: `${theme.spacing(1.5, 4, 1.5, 4)} !important`,
            marginBottom: '1rem',
        },
        selected: {
            color: theme.palette.primary.main,
        },
        icon: {
            color: theme.palette.text.secondary,
            transition: '.3s',
            '& svg': {
                fill: theme.palette.text.secondary,
                transition: '.3s',
            },
            '&:hover': {
                color: theme.palette.text.primary,
                '& svg': {
                    fill: theme.palette.text.primary,
                },
            },
        },
    };
});
